<app-menu>
  <div class="tpo-shell" [attr.data-theme]="themeMode">
    <div class="mx-auto flex h-[calc(100vh-64px)] min-h-[calc(100vh-64px)] max-w-[1900px] flex-col gap-2 px-3 py-2">
      <header class="tpo-toolbar">
        <div class="min-w-0 flex-1">
          <div class="flex min-w-0 flex-wrap items-center gap-2">
            <div class="tpo-eyebrow">Inventory / Package Operations</div>
            <span class="tpo-status-pill" [ngClass]="statusClass">
              <i class="fa-solid" [ngClass]="statusTone === 'error' ? 'fa-circle-xmark' : statusTone === 'warning' ? 'fa-spinner fa-spin' : statusTone === 'ready' ? 'fa-circle-check' : 'fa-circle-info'"></i>
              {{ statusLabel }}
            </span>
          </div>
          <div class="mt-1 flex min-w-0 flex-wrap items-center gap-3">
            <h1 class="truncate">Trip Package Operations</h1>
            <div class="tpo-meta-strip">
              <span><strong>{{ totalRows }}</strong> trips</span>
              <span><strong>{{ loadedRows }}</strong> loaded</span>
              <span><strong>{{ formatLastLoaded() }}</strong> refresh</span>
            </div>
          </div>
        </div>

        <div class="tpo-toolbar-actions">
          <button type="button" class="tpo-button tpo-button--ghost" (click)="toggleTheme()" [title]="getThemeLabel() + ' theme'">
            <i [class]="getThemeIcon()"></i>
            <span>{{ getThemeLabel() }}</span>
          </button>
          <button type="button" class="tpo-button tpo-button--ghost" (click)="refreshGrid()" [disabled]="loadingRows">
            <i class="fa-solid fa-rotate" [class.fa-spin]="loadingRows"></i>
            <span>{{ loadingRows ? 'Loading' : 'Refresh' }}</span>
          </button>
          <button type="button" class="tpo-button tpo-button--primary" (click)="packageIntake()">
            <i class="fa-solid fa-box-open"></i>
            <span>New Intake</span>
          </button>
        </div>
      </header>

      <section class="tpo-action-strip">
        <button type="button" class="tpo-action-chip" (click)="storeReports()" title="Store report">
          <i class="fa-solid fa-house"></i>
          <span>Store Report</span>
        </button>
        <button type="button" class="tpo-action-chip" (click)="exceptionReports()" title="Exception report">
          <i class="fa-solid fa-check"></i>
          <span>Exception Report</span>
        </button>
        <button type="button" class="tpo-action-chip" (click)="deliveryReports()" title="Delivery report">
          <i class="fa-solid fa-truck"></i>
          <span>Delivery Report</span>
        </button>
        <button type="button" class="tpo-action-chip" (click)="uploadYoshinoFile()" title="Yoshino upload">
          <i class="fa-solid fa-file-arrow-up"></i>
          <span>Yoshino Upload</span>
        </button>
      </section>

      <div *ngIf="errorMessage" class="tpo-alert tpo-alert--error">
        <i class="fa-solid fa-triangle-exclamation"></i>
        <span>{{ errorMessage }}</span>
        <button type="button" (click)="errorMessage = ''"><i class="fa-solid fa-xmark"></i></button>
      </div>

      <section class="tpo-grid-shell min-h-0 flex-1">
        <div class="tpo-grid-head">
          <div class="flex min-w-0 items-center gap-2">
            <div class="tpo-eyebrow">Trips</div>
            <h2>Package Workbench</h2>
          </div>
          <div class="tpo-grid-hints">
            <span><i class="fa-solid fa-tags"></i> labels</span>
            <span><i class="fa-solid fa-file-arrow-up"></i> append</span>
          </div>
        </div>

        <ag-grid-angular
          [class]="themeClass"
          [columnDefs]="columnDefs"
          [defaultColDef]="defaultColDef"
          [animateRows]="true"
          [rowModelType]="'serverSide'"
          [cacheBlockSize]="100"
          [detailCellRenderer]="detailCellRenderer"
          [masterDetail]="true"
          [detailRowHeight]="318"
          [getContextMenuItems]="getContextMenuItems"
          [rowClassRules]="rowClassRules"
          (gridReady)="onGridReady($event)">
        </ag-grid-angular>
      </section>
    </div>
  </div>
</app-menu>
